// docs/144: starter garb. Every class has plain clothes of its own (a fighter's red gambeson, a wizard's starry
// robe and pointed hat, a bard's feathered cap), real items (fk-grammar `garb.rs`, ids 900–979) a new hero is
// given with its kit: worn, taken off, traded and sold like any other piece. The names and flavour are in
// content/items/garb.json; the art is ITEM_ART's (docs/129 rules).
import garb from '../../../../content/items/garb.json';
import type { Slot } from './itemArt';

export interface GarbPiece {
  id: number;
  /** The class it was cut for (`CLASS_NAMES`). */
  cls: string;
  slot: Slot;
  name: string;
  flavour: string;
}

export const GARB: readonly GarbPiece[] = garb.pieces as GarbPiece[];
const BY_ID = new Map(GARB.map((p) => [p.id, p]));

/** The garb piece with this def id. */
export const garbPiece = (def: number): GarbPiece | undefined => BY_ID.get(def);
export const isGarb = (def: number): boolean => def >= 900 && def < 1000;

/** SG4: a class's piece of one cut (0 body, 1 legs, 2 feet, 3 head, 4 back, 5 waist; 6 light body, 7 second head). */
export const garbCut = (classIndex: number, unit: number): number | undefined => BY_ID.get(900 + 10 * classIndex + unit)?.id;
